import { render, staticRenderFns } from "./TrendingItems.vue?vue&type=template&id=1538dcf6&scoped=true"
import script from "./TrendingItems.vue?vue&type=script&lang=js"
export * from "./TrendingItems.vue?vue&type=script&lang=js"
import style0 from "./TrendingItems.vue?vue&type=style&index=0&id=1538dcf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1538dcf6",
  null
  
)

export default component.exports